import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function Forms() {
    return (
        <>
            <Container fluid>
                <Col>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>انواع فرم ها</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>داشبورد</Link>
                            </li>
                            <li className='breadcrumb-item'>
                                <Link to='/forms'>انواع فرم ها</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </Col>

                <div className='space-20' />

                <Row>
                    <div className='col-md-12 col-lg-6 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                فرم های نوشتاری
                            </div>

                            <div className='card-body'>
                                <div className='mb-3'>
                                    <label
                                        htmlFor='exampleFormControlInput'
                                        className='form-label'
                                    >
                                        آدرس ایمیل
                                    </label>

                                    <input
                                        type='text'
                                        className='form-control'
                                        id='exampleFormControlInput'
                                        placeholder='iam@amirreza.dev'
                                    />
                                </div>

                                <div className='mb-3'>
                                    <label
                                        htmlFor='exampleFormControlInput1'
                                        className='form-label'
                                    >
                                        رمز عبور
                                    </label>
                                    <input
                                        type='password'
                                        className='form-control'
                                        id='exampleFormControlInput1'
                                        placeholder='123456'
                                    />
                                </div>

                                <div className='mb-3'>
                                    <label
                                        htmlFor='exampleFormControlInput1'
                                        className='form-label'
                                    >
                                        فیلد غیر فعال
                                    </label>
                                    <input
                                        className='form-control'
                                        type='text'
                                        placeholder='فیلد غیر فعال'
                                        aria-label='Disabled input example'
                                        disabled
                                    />
                                </div>

                                <div className='mb-3'>
                                    <label
                                        htmlFor='formFile'
                                        className='form-label'
                                    >
                                        فیلد ارسال فایل
                                    </label>

                                    <input
                                        className='form-control'
                                        type='file'
                                        id='formFile'
                                    />
                                </div>

                                <div className='mb-3'>
                                    <label
                                        htmlFor='exampleFormControlTextarea1'
                                        className='form-label'
                                    >
                                        باکس نوشتاری
                                    </label>
                                    <textarea
                                        className='form-control'
                                        id='exampleFormControlTextarea1'
                                        rows='3'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 col-lg-6 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                فرم های انتخابی
                            </div>

                            <div className='card-body'>
                                <div className='mb-5'>
                                    <select
                                        className='form-select'
                                        aria-label='Default select example'
                                    >
                                        <option defaultValue>
                                            با کلیک منو را باز کنید
                                        </option>
                                        <option defaultValue='1'>یک</option>
                                        <option defaultValue='2'>دو</option>
                                        <option defaultValue='3'>سه</option>
                                    </select>
                                </div>

                                <div className='row mb-3'>
                                    <div className='col-6'>
                                        <div className='form-check'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id='flexCheckDefault'
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexCheckDefault'
                                            >
                                                چک باکس معولی
                                            </label>
                                        </div>

                                        <div className='form-check'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id='flexCheckChecked'
                                                defaultChecked
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexCheckChecked'
                                            >
                                                چک باکس انتخاب شده
                                            </label>
                                        </div>

                                        <div className='form-check'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id='defaultCheck2'
                                                disabled
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='defaultCheck2'
                                            >
                                                چک باکس غیر فعال
                                            </label>
                                        </div>
                                    </div>

                                    <div className='col-6'>
                                        <div className='form-check'>
                                            <input
                                                className='form-check-input'
                                                type='radio'
                                                name='flexRadioDefault'
                                                id='flexRadioDefault1'
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexRadioDefault1'
                                            >
                                                رادیو معمولی
                                            </label>
                                        </div>

                                        <div className='form-check'>
                                            <input
                                                className='form-check-input'
                                                type='radio'
                                                name='flexRadioDefault'
                                                id='flexRadioDefault2'
                                                defaultChecked
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexRadioDefault2'
                                            >
                                                رادیو انتخاب شده
                                            </label>
                                        </div>

                                        <div className='form-check'>
                                            <input
                                                className='form-check-input'
                                                type='radio'
                                                name='exampleRadios'
                                                id='flexRadioDefault3'
                                                disabled
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexRadioDefault3'
                                            >
                                                رادیو غیر فعال
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className='row mb-3'>
                                    <div className='col-6'>
                                        <div className='form-check form-switch'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id='flexSwitchCheckDefault'
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexSwitchCheckDefault'
                                            >
                                                سوییچ معمولی
                                            </label>
                                        </div>
                                        <div className='form-check form-switch'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id='flexSwitchCheckChecked'
                                                defaultChecked
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexSwitchCheckChecked'
                                            >
                                                سوییچ انتخاب شده
                                            </label>
                                        </div>
                                    </div>

                                    <div className='col-6'>
                                        <div className='form-check form-switch'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id='flexSwitchCheckDisabled'
                                                disabled
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexSwitchCheckDisabled'
                                            >
                                                سوییچ معمولی غیر فعال
                                            </label>
                                        </div>
                                        <div className='form-check form-switch'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                id='flexSwitchCheckCheckedDisabled'
                                                defaultChecked
                                                disabled
                                            />
                                            <label
                                                className='form-check-label'
                                                htmlFor='flexSwitchCheckCheckedDisabled'
                                            >
                                                سوییچ انتخاب شده غیر فعال
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='mt-4 mb-4'>
                                            <label
                                                htmlFor='customRange1'
                                                className='form-label'
                                            >
                                                تعیین محدوده
                                            </label>
                                            <input
                                                type='range'
                                                className='form-range'
                                                id='customRange1'
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='row mb-2'>
                                    <div className='col-12'>
                                        <label className='mb-4'>
                                            رادیو و چک باکس دکمه ای
                                        </label>

                                        <br />

                                        <input
                                            type='checkbox'
                                            className='btn-check'
                                            id='btn-check-outlined'
                                            autoComplete='off'
                                        />
                                        <label
                                            className='btn btn-outline-primary mr-3'
                                            htmlFor='btn-check-outlined'
                                        >
                                            چک باکس تکی
                                        </label>

                                        <input
                                            type='checkbox'
                                            className='btn-check'
                                            id='btn-check-2-outlined'
                                            defaultChecked
                                            autoComplete='off'
                                        />
                                        <label
                                            className='btn btn-outline-secondary mr-3'
                                            htmlFor='btn-check-2-outlined'
                                        >
                                            انتخاب شده
                                        </label>

                                        <input
                                            type='radio'
                                            className='btn-check'
                                            name='options-outlined'
                                            id='success-outlined'
                                            autoComplete='off'
                                            defaultChecked
                                        />
                                        <label
                                            className='btn btn-outline-success mr-3'
                                            htmlFor='success-outlined'
                                        >
                                            دکمه رادیو انتخاب شده
                                        </label>

                                        <input
                                            type='radio'
                                            className='btn-check'
                                            name='options-outlined'
                                            id='danger-outlined'
                                            autoComplete='off'
                                        />
                                        <label
                                            className='btn btn-outline-danger mr-3'
                                            htmlFor='danger-outlined'
                                        >
                                            دکمه رادیو اخطار
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Row>

                <Row>
                    <Col className='mb-4' md={12} lg={6}>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                انواع فرم های نوشتاری
                            </div>

                            <Card.Body>
                                <form
                                    className='row g-3 needs-validation'
                                    noValidate
                                >
                                    <div className='col-md-4'>
                                        <label
                                            htmlFor='validationCustom01'
                                            className='form-label'
                                        >
                                            نام
                                        </label>

                                        <input
                                            type='text'
                                            className='form-control'
                                            id='validationCustom01'
                                            defaultValue='Mark'
                                            required
                                        />

                                        <div className='valid-feedback'>
                                            Looks good!
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <label
                                            htmlFor='validationCustom02'
                                            className='form-label'
                                        >
                                            نام خانوادگی
                                        </label>

                                        <input
                                            type='text'
                                            className='form-control'
                                            id='validationCustom02'
                                            defaultValue='Otto'
                                            required
                                        />

                                        <div className='valid-feedback'>
                                            Looks good!
                                        </div>
                                    </div>

                                    <div className='col-md-4'>
                                        <label
                                            htmlFor='validationCustomUsername'
                                            className='form-label'
                                        >
                                            نام کاربری
                                        </label>

                                        <div className='input-group has-validation'>
                                            <span
                                                className='input-group-text'
                                                id='inputGroupPrepend'
                                            >
                                                @
                                            </span>

                                            <input
                                                type='text'
                                                className='form-control'
                                                id='validationCustomUsername'
                                                aria-describedby='inputGroupPrepend'
                                                required
                                            />

                                            <div className='invalid-feedback'>
                                                Please choose a username.
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-6'>
                                        <label
                                            htmlFor='validationCustom03'
                                            className='form-label'
                                        >
                                            آدرس
                                        </label>

                                        <input
                                            type='text'
                                            className='form-control'
                                            id='validationCustom03'
                                            required
                                        />

                                        <div className='invalid-feedback'>
                                            Please provide a valid city.
                                        </div>
                                    </div>

                                    <div className='col-md-3'>
                                        <label
                                            htmlFor='validationCustom04'
                                            className='form-label'
                                        >
                                            استان
                                        </label>

                                        <select
                                            className='form-select'
                                            id='validationCustom04'
                                            required
                                        >
                                            <option disabled defaultValue>
                                                Choose...
                                            </option>
                                            <option>...</option>
                                        </select>

                                        <div className='invalid-feedback'>
                                            Please select a valid state.
                                        </div>
                                    </div>

                                    <div className='col-md-3'>
                                        <label
                                            htmlFor='validationCustom05'
                                            className='form-label'
                                        >
                                            کدپستی
                                        </label>

                                        <input
                                            type='text'
                                            className='form-control'
                                            id='validationCustom05'
                                            required
                                        />

                                        <div className='invalid-feedback'>
                                            Please provide a valid zip.
                                        </div>
                                    </div>

                                    <div className='col-12'>
                                        <div className='form-check'>
                                            <input
                                                className='form-check-input'
                                                type='checkbox'
                                                defaultValue=''
                                                id='invalidCheck'
                                                required
                                            />

                                            <label
                                                className='form-check-label'
                                                htmlFor='invalidCheck'
                                            >
                                                با تمام شرایط سایت موافقم
                                            </label>

                                            <div className='invalid-feedback'>
                                                You must agree before
                                                submitting.
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-12'>
                                        <button
                                            className='btn btn-primary'
                                            type='submit'
                                        >
                                            ثبت نام
                                        </button>
                                    </div>
                                </form>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={12} lg={6}>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                انواع فرم های نوشتاری
                            </div>

                            <Card.Body>
                                <div className='input-group mb-3'>
                                    <span
                                        className='input-group-text'
                                        id='basic-addon1'
                                    >
                                        @
                                    </span>
                                    <input
                                        type='text'
                                        className='form-control'
                                        placeholder='Username'
                                        aria-label='Username'
                                        aria-describedby='basic-addon1'
                                    />
                                </div>

                                <div className='input-group mb-3'>
                                    <input
                                        type='text'
                                        className='form-control'
                                        placeholder="Recipient's username"
                                        aria-label="Recipient's username"
                                        aria-describedby='basic-addon2'
                                    />
                                    <span
                                        className='input-group-text'
                                        id='basic-addon2'
                                    >
                                        @example.com
                                    </span>
                                </div>

                                <label
                                    htmlFor='basic-url'
                                    className='form-label'
                                >
                                    Your vanity URL
                                </label>
                                <div className='input-group mb-3'>
                                    <span
                                        className='input-group-text'
                                        id='basic-addon3'
                                    >
                                        https://example.com/users/
                                    </span>
                                    <input
                                        type='text'
                                        className='form-control'
                                        id='basic-url'
                                        aria-describedby='basic-addon3'
                                    />
                                </div>

                                <div className='input-group mb-3'>
                                    <span className='input-group-text'>$</span>
                                    <input
                                        type='text'
                                        className='form-control'
                                        aria-label='Amount (to the nearest dollar)'
                                    />
                                    <span className='input-group-text'>
                                        .00
                                    </span>
                                </div>

                                <div className='input-group mb-3'>
                                    <input
                                        type='text'
                                        className='form-control'
                                        placeholder='Username'
                                        aria-label='Username'
                                    />
                                    <span className='input-group-text'>@</span>
                                    <input
                                        type='text'
                                        className='form-control'
                                        placeholder='Server'
                                        aria-label='Server'
                                    />
                                </div>

                                <div className='input-group'>
                                    <span className='input-group-text'>
                                        With textarea
                                    </span>
                                    <textarea
                                        className='form-control'
                                        aria-label='With textarea'
                                    />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
